<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Order Management</h4>
        </div>

    </div>
</div>
<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <diV class="row">
                                <div class="col-sm-12 col-md-8">
                                </div>
                            </diV>
                            <div>
                                
                                <nav>
                                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                        <a class="nav-item  nav-link active" id="nav-Active-tab" data-toggle="tab"
                                            href="#nav-Active" role="button" aria-controls="nav-Active"
                                            aria-selected="false"> Active
                                        </a>
                                        <a class="nav-item  nav-link " id="nav-Completed-tab" data-toggle="tab"
                                            href="#nav-Completed" role="button" aria-controls="nav-Completed"
                                            aria-selected="false">Completed
                                        </a>
                                        <a class="nav-item nav-link" id="nav-Cancelled-tab" data-toggle="tab"
                                            href="#nav-Cancelled" role="tab" aria-controls="nav-Cancelled"
                                            aria-selected="false">Cancelled</a>

                                    </div>
                                </nav>
                                <div class="tab-content" id="nav-tabContent">
                                    <!--Active-->
                              
                                    <div class="tab-pane fade show active" id="nav-Active" role="tabpanel"
                                        aria-labelledby="nav-myposts-tab">
                                        <div class="row mt-1">
                                            <div class="col-md-10">
                                                <div id="zero_config_filter" class="dataTables_filter">
                                                    <button style="background-color: #e0e09e" (click)="filter()">
                                                        <i class="fa fa-filter" aria-hidden="true"></i>
                                                        Filter</button>
                                                </div>
                                            </div>
            
                                            <div class="col-md-2" >
            
                                                <div id="zero_config_filter" style="float: left;" class="dataTables_filter" (click)="exportActiveTable()">
                                                    <button style="background-color: #e0e09e">
                                                        <i class="fa fa-download" aria-hidden="true"></i>
                                                        Export</button>
                                                </div>
            
                                            </div>
                                        </div>

                                        <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                            <div class="container-fluid" style="color: black">
                                              
                                                <input type="radio" id="emailId" name="email" [(ngModel)]="filterValueSelected"
                                                    value="ei" (change)="applyCustomizedFilter()" style="margin-top: 29px;">User Account Email Id &nbsp;&nbsp;
                                               
                                                <input type="radio" id="orderid" name="order" style="margin-top: 29px;" [(ngModel)]="filterValueSelected"
                                                    value="oi" (change)="applyCustomizedFilter()"> Order Id &nbsp;&nbsp;
                                                <input type="radio" id="vendorid" name="vendor" style="margin-top: 29px;" [(ngModel)]="filterValueSelected"
                                                    value="vn" (change)="applyCustomizedFilter()">Vendor Name&nbsp;&nbsp;
            
            
                                            </div>
                                            <div style="margin-left: 820px">
            
                                                <button class="btn btn-dark" (click)="filter()">Cancel</button>
            
                                            </div>
                                        </div>
                                        <br>
                                        <div>
                                            <div>
                                                <mat-form-field *ngIf="showCustomisedSearch">
            
                                                    <input class="search" placeholder="Search" matInput [(ngModel)]="searchValue"
                                                        (keyup)="applyCustomizedFilterSearch(searchValue)">
            
                                                </mat-form-field>
                                                <mat-form-field *ngIf="!showCustomisedSearch">
                                                    <input class="search" placeholder="Search" matInput
                                                        (keyup)="applyFilter($event.target.value)">
            
                                                </mat-form-field>
            
                                            </div>
                                        <div class="table-responsive">
                                            <table class="table table-hover" mat-table [dataSource]="dataSource"
                                                #firstTableSort="matSort" matSort>
                                                <ng-container matColumnDef="orderId">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Order Id</th>
                                                    <td *matCellDef="let row">
                                                        {{row.orderId}}

                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="accountDetails.vendorName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Vendor Name</th>
                                                    <td *matCellDef="let row" >
                                                        {{row.accountDetails.vendorName}}

                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="userAccountEmailId">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        User Account Email ID</th>
                                                    <td *matCellDef="let row">
                                                        {{row.userAccountEmailId }}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="orderStatus">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Order Status</th>
                                                    <td *matCellDef="let row">
                                                        {{row.orderStatus}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="productsList">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        PRODUCTS LIST</th>
                                                    <td *matCellDef="let row">
                                                        <button  data-toggle="modal"  data-target="#exampleModalCenter" (click)="getProductsDetailsByhistoryId(row._id,'Pending')">Product Details</button>
                                                    </td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef='displayedActiveColumns'>
                                                </tr>
                                                <tr mat-row *matRowDef="let row;columns:displayedActiveColumns"></tr>
                                            </table>
                                        </div>
                                        </div>
                                        <mat-paginator #TableOnePaginator="matPaginator" [length]="100" [pageSize]="10"
                                            [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                                        </mat-paginator>
                                    </div>
                                    <!--Completed-->
                                    <div class="tab-pane fade" id="nav-Completed" role="tabpanel"
                                        aria-labelledby="nav-mydeletions-tab">
                                        <div class="row mt-1">
                                            <div class="col-md-10">
                                                <div id="zero_config_filter" class="dataTables_filter">
                                                    <button style="background-color: #e0e09e" (click)="filterForCompletedOrders()">
                                                        <i class="fa fa-filter" aria-hidden="true"></i>
                                                        Filter</button>
                                                </div>
                                            </div>
            
                                            <div class="col-md-2" >
            
                                                <div id="zero_config_filter" style="float: left;" class="dataTables_filter" (click)="exportCompletedTable()">
                                                    <button style="background-color: #e0e09e">
                                                        <i class="fa fa-download" aria-hidden="true"></i>
                                                        Export</button>
                                                </div>
            
                                            </div>
                                        </div>
                                        <div *ngIf="showFilterCompleted" style="background-color: #e0e09e;width: 895px;">
                                            <div class="container-fluid" style="color: black">
                                              
                                                <input type="radio" id="emailId" name="email" [(ngModel)]="filterValueSelectedCompleted"
                                                value="ei" (change)="applyCustomizedFilterForCompletedOrders()" style="margin-top: 29px;">User Account Email Id &nbsp;&nbsp;
                                           
                                            <input type="radio" id="orderid" name="order" style="margin-top: 29px;" [(ngModel)]="filterValueSelectedCompleted"
                                                value="oi" (change)="applyCustomizedFilterForCompletedOrders()"> Order Id &nbsp;&nbsp;
                                            <input type="radio" id="vendorid" name="vendor" style="margin-top: 29px;" [(ngModel)]="filterValueSelectedCompleted"
                                                value="vn" (change)="applyCustomizedFilterForCompletedOrders()">Vendor Name&nbsp;&nbsp;
            
                                            </div>
                                            <div style="margin-left: 820px">
            
                                                <button class="btn btn-dark" (click)="filterForCompletedOrders()">Cancel</button>
            
                                            </div>
                                        </div>
                                        <br>
                                        <div>
                                            <div>
                                                <mat-form-field *ngIf="showCustomisedSearchCompleted">
            
                                                    <input class="search" placeholder="Search" matInput [(ngModel)]="searchValueCompleted"
                                                        (keyup)="applyCustomizedFilterSearchForCompletedOrders(searchValueCompleted)">
            
                                                </mat-form-field>
                                                <mat-form-field *ngIf="!showCustomisedSearchCompleted">
                                                    <input class="search" placeholder="Search" matInput
                                                        (keyup)="applyFilter($event.target.value)">
            
                                                </mat-form-field>
            
                                            </div>
                                        <div class="table-responsive">
                                            <table class="table table-hover" mat-table
                                                [dataSource]="dataSourceCompleted" #secondTableSort="matSort" matSort>


                                                <ng-container matColumnDef="orderId">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Order Id</th>
                                                    <td *matCellDef="let row">
                                                        {{row.orderId}}

                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="accountDetails.vendorName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Vendor Name</th>
                                                    <td *matCellDef="let row" >
                                                        {{row.accountDetails.vendorName}}

                                                    </td>
                                                </ng-container>


                                                <ng-container matColumnDef="userAccountEmailId">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        User Account Email ID</th>
                                                    <td *matCellDef="let row">
                                                        {{row.userAccountEmailId }}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="orderStatus">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Order Status</th>
                                                    <td *matCellDef="let row">
                                                        {{row.orderStatus}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="productsList">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        PRODUCTS LIST</th>
                                                    <td *matCellDef="let row">
                                                        <button  data-toggle="modal"  data-target="#exampleModalCenter" (click)="getProductsDetailsByhistoryId(row._id,'Completed')">Product Details</button>
                                                    </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef='displayedCompletedColumns'>
                                                </tr>
                                                <tr mat-row *matRowDef="let row;columns:displayedCompletedColumns"></tr>
                                            </table>
                                        </div>
                                        </div>
                                        <mat-paginator #TableTwoPaginator [length]="100" [pageSize]="10"
                                            [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                                        </mat-paginator>
                                    </div>
                                    <!--Cancelled-->
                                    <div class="tab-pane fade" id="nav-Cancelled" role="tabpanel"
                                        aria-labelledby="nav-allpost-tab">
                                        <div class="row mt-1">
                                            <div class="col-md-10">
                                                <div id="zero_config_filter" class="dataTables_filter">
                                                    <button style="background-color: #e0e09e"  (click)="filterForCancelledOrders()">
                                                        <i class="fa fa-filter" aria-hidden="true"></i>
                                                        Filter</button>
                                                </div>
                                            </div>
            
                                            <div class="col-md-2" >
            
                                                <div id="zero_config_filter" style="float: left;" class="dataTables_filter" (click)="exportCancelledTable()">
                                                    <button style="background-color: #e0e09e">
                                                        <i class="fa fa-download" aria-hidden="true"></i>
                                                        Export</button>
                                                </div>
            
                                            </div>
                                        </div>
                                        <div *ngIf="showFilterCancelled" style="background-color: #e0e09e;width: 895px;">
                                            <div class="container-fluid" style="color: black">
                                              
                                                <input type="radio" id="emailId" name="email" [(ngModel)]="filterValueSelectedCancelled"
                                                value="ei" (change)="applyCustomizedFilterForCancelledOrders()" style="margin-top: 29px;">User Account Email Id &nbsp;&nbsp;
                                           
                                            <input type="radio" id="orderid" name="order" style="margin-top: 29px;" [(ngModel)]="filterValueSelectedCancelled"
                                                value="oi" (change)="applyCustomizedFilterForCancelledOrders()"> Order Id &nbsp;&nbsp;
                                            <input type="radio" id="vendorid" name="vendor" style="margin-top: 29px;" [(ngModel)]="filterValueSelectedCancelled"
                                                value="vn" (change)="applyCustomizedFilterForCancelledOrders()">Vendor Name&nbsp;&nbsp;
            
                                            </div>
                                            <div style="margin-left: 820px">
            
                                                <button class="btn btn-dark" (click)="filterForCancelledOrders()">Cancel</button>
            
                                            </div>
                                        </div>
                                        <br>
                                        <div>
                                            <div>
                                                <mat-form-field *ngIf="showCustomisedSearchCancelled">
            
                                                    <input class="search" placeholder="Search" matInput [(ngModel)]="searchValueCancelled"
                                                        (keyup)="applyCustomizedFilterSearchForCancelledOrders(searchValueCancelled)">
            
                                                </mat-form-field>
                                                <mat-form-field *ngIf="!showCustomisedSearchCancelled">
                                                    <input class="search" placeholder="Search" matInput
                                                        (keyup)="applyFilter($event.target.value)">
            
                                                </mat-form-field>
            
                                            </div>
                                        <div class="table-responsive">
                                            <table class="table table-hover" mat-table
                                                [dataSource]="dataSourceCancelled" #thirdTableSort="matSort" matSort>
                                                <ng-container matColumnDef="orderId">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Order Id</th>
                                                    <td *matCellDef="let row">
                                                        {{row.orderId}}

                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="accountDetails.vendorName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Vendor Name</th>
                                                    <td *matCellDef="let row" >
                                                        {{row.accountDetails.vendorName}}

                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="userAccountEmailId">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        User Account Email ID</th>
                                                    <td *matCellDef="let row">
                                                        {{row.userAccountEmailId }}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="orderStatus">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        ORDER STATUS</th>
                                                    <td *matCellDef="let row">
                                                        {{row.orderStatus}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="productsList">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        PRODUCTS LIST</th>
                                                    <td *matCellDef="let row">
                                                        <button (click)="getProductsDetailsByhistoryId(row._id,'Cancelled')" data-toggle="modal"  data-target="#exampleModalCenter">Product Details</button>
                                                    </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef='displayedCancelledColumns'>
                                                </tr>
                                                <tr mat-row *matRowDef="let row;columns:displayedCancelledColumns"></tr>
                                            </table>
                                        </div>
                                        </div>
                                        <mat-paginator #TableThreePaginator [length]="100" [pageSize]="10"
                                            [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                                        </mat-paginator>
                                    </div>



                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<!-- ============================================================== -->
<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="viewMyPost">Products Details</h2>
                <button type="button" class="close" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table" id="Example table" mat-table
                        [dataSource]="dataSourceProductDetails"  style=" margin-top: 30px;">
                      
                       
                      
                        <ng-container matColumnDef="productName">
                             <th mat-header-cell *matHeaderCellDef >Product Name</th>
                            <td *matCellDef="let row">{{row.productsResult.productName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="productImage">
                            <th mat-header-cell *matHeaderCellDef >Product Image</th>
                            <td *matCellDef="let row" style="white-space: nowrap;">
                              
                                <button class="dropdown-item" data-toggle="modal"
                                 data-target="#responsiveImages"
                                style="color:rgb(30, 110, 124)" (click)="viewImages(row.productsResult._id)">
                               View
                                </button>
                            </td>
                        </ng-container>
                       <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef > Description</th>
                            <td *matCellDef="let row">{{row.productsResult.description}}</td>
                        </ng-container>
                       
                         <ng-container matColumnDef="actualPrice">
                            <th mat-header-cell *matHeaderCellDef >Actual Price</th>
                            <td *matCellDef="let row">{{row.productsResult.actualPrice}}</td>
                        </ng-container>
                      
                       
                        <ng-container matColumnDef="offeredPrice">
                            <th mat-header-cell *matHeaderCellDef >Offered Price</th>
                            <td *matCellDef="let row">{{row.productsResult.offeredPrice}}</td>

                        </ng-container>
                        <ng-container matColumnDef="stockQuantity">
                            <th mat-header-cell *matHeaderCellDef >Stock Quantity</th>
                            <td *matCellDef="let row">{{row.productsResult.stockQuantity}}</td>

                        </ng-container>
                       
                     


                        <tr mat-header-row *matHeaderRowDef='displayedColumnsProductDetails'>
                        </tr>
                        <tr mat-row *matRowDef="let row;columns:displayedColumnsProductDetails"></tr>
                    </table>
                </div>
            
            </div>
        </div>
    </div>
</div>

<div id="responsiveImages" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content" style="width:900px">
            <div class="modal-header">
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_0'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_1'}}"
                width="100" height="100" />
                <img  style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_2'}}"
                width="100" height="100" />
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_3'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_4'}}"
                width="100" height="100" />
                <img  style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_5'}}"
                width="100" height="100" />
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_6'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_7'}}"
                width="100" height="100" />
 
            </div>
        </div>
    </div>
</div>